'use client';

import {
  Box,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  IconButton,
} from '@chakra-ui/react';
import React from 'react';
import { Suspense } from 'react';

import { ReactComponent as FilterIcon } from '@/app/used-cars/_icons/filter.svg';
import { useFiltersModal } from '@/hooks/used-cars/new-filters.hook';

import FilterBadge from '../../../search/filter-badge/filter-badge';

import styles from './mobile-filter-modal.module.scss';

export default function MobileFilterModal({
  children,
  count,
}: {
  children: React.ReactNode;
  count: number;
}) {
  const { openFiltersModal, closeFiltersModal, isDrawerOpen } =
    useFiltersModal();

  return (
    <>
      <Box position="relative" display={{ base: 'block', lg: 'none' }}>
        <IconButton
          aria-label="Open Filters"
          className={styles.filterIcon}
          onClick={openFiltersModal}
        >
          <FilterIcon />
        </IconButton>
        <FilterBadge className={styles.filterBadge} count={count} />
      </Box>
      <Suspense fallback={null}>
        <Drawer
          isOpen={isDrawerOpen}
          placement="right"
          onClose={() => {
            closeFiltersModal();
          }}
        >
          <DrawerOverlay />
          <DrawerContent maxWidth={{ base: '100%', md: '460px' }}>
            <DrawerCloseButton />
            <DrawerBody paddingTop={10} paddingLeft={4} paddingRight={4}>
              {children}
            </DrawerBody>
          </DrawerContent>
        </Drawer>
      </Suspense>
    </>
  );
}
